import { doPost, toUrl, getSearchQuery } from "./lib.js";
export async function groupGraphEvents(clientInfo, input) {
    const url = toUrl(clientInfo.orgId, "graph/groupBys");
    const json = await doPost(url, clientInfo, getSearchQuery(input));
    return json; // believe me
}
